document.addEventListener('alpine:init', () => {
    window.Alpine.data('logout', () => ({
        logout() {
            window.api.post('/api/logout')
                .then((response) => {
                    window.Alpine.store('user', {})
                    window.location.replace(response.data.referrer || `${window.location.protocol}//${window.location.host}`)
                })
        },
    }))
})
